import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { EditmenusearchPage } from "../editmenusearch/editmenusearch";
import { SERVER_URL } from "../../config";
/**
 * Generated class for the RicercamenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-ricercamenu',
  templateUrl: 'ricercamenu.html',
})
export class RicercamenuPage {
  public searchTerm;
  public numResult;
  menus: string[];
  errorMessage: string;
  link;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider

  ) {
    this.link = SERVER_URL + "/manifesti/files/"

    this.searchTerm=navParams.get('searchTerm');
    if(this.searchTerm!=null){
     this.setFilteredItems();
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RicercaPage');
    
  }
  setFilteredItems() {
    console.log(this.searchTerm);
    if (this.searchTerm.length > 2) {
      this.rest.searcMenus(this.searchTerm).subscribe(
        menus => this.menus = menus,
        error => this.errorMessage = <any>error);
      if (this.menus != null) {
      this.numResult = Object.keys(this.menus).length;
        this.LoadData();
      }
    }
  }
  public LoadData() {
    console.log("LoadData this.articoli:" + JSON.stringify(this.menus));

    console.log("LoadData");

  }
  openEditmenuPage(menu) {

    this.navCtrl.push(EditmenusearchPage, { menu: menu ,searchTerm:this.searchTerm});


  }
}



// WEBPACK FOOTER //
// ./src/pages/ricercamenu/ricercamenu.ts